// src/pages/Contact.js
import React from 'react';
import CtaSection from '../components/CtaSection';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer'; // Reuse the Footer component
import ComprehensiveSection from '../components/ComprehensiveSection';
import Testimonials from '../components/Testimonials';
import logo1 from '../assets/emr.png';
import logo2 from '../assets/digital-footprint.png';
import logo3 from '../assets/digital-outreach.png';
import logo4 from '../assets/billing-and-payments.png';
import logo5 from '../assets/data-and-insights.png';
import { Helmet } from 'react-helmet';

const Demo = () => {

  //passing data dynamically to comprehensive section
  const blockData = [
    {
      logo: logo1,
      title: 'EMR',
      text: 'Experience a certified EHR solution offering robust charting, documentation, patient histories, eRx, eLabs, telehealth, and customizable care delivery.',
      link: '/emr',
    },
    {
      logo: logo2,
      title: 'Digital Footprint',
      text: 'Expand your practice with secure websites, expert SEO, search marketing tools, reputation management, web profiles, and social media management.',
      link: '/digital-footprint',
    },
    {
      logo: logo3,
      title: 'Digital Outreach',
      text: 'Expand your reach through search marketing tools, automated reputation management, polished web profiles, and effective social media management.',
      link: '/digital-outreach',
    },
    {
      logo: logo4,
      title: 'Billing & Payments',
      text: 'Enroll, submit, and track on a unified platform. Gain financial visibility with reporting, analytics, automation, and streamlined payment methods for faster collections.',
      link: '/billing-and-payments',
    },
    {
      logo: logo5,
      title: 'Data & Insights',
      text: 'Get deeper insights of your practice growth, patient revenue with Doclivo analytics. Unlock valuable data and insights to drive informed decisions and improve performance.',
      link: '/data-and-insights',
    },
  ];

  return (
    <div>
      <Helmet>
                <title> Demo - Doclivo</title>
                <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
                <meta name="keywords" content="about us, company, automation" />
            </Helmet>
      <Navbar></Navbar>
      <section className="demo-section">

        <CtaSection></CtaSection>

        <ComprehensiveSection blockData={blockData} />
        {/* <Testimonials></Testimonials> */}
      </section>
      <Footer />
    </div>
  );
};

export default Demo;
